import React, { useEffect, useMemo, useRef, useState } from "react";

import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import NotFoundPage from "pages/NotFoundPage";

import { LeftMenu } from "../../../../features/menus/Left";
import {
  IListItem,
  IListNavigation,
} from "../../../../features/menus/Left/interface";
import { usePermissions } from "../../../../hooks/permission";
import { FORMS_RELATORIOS } from "../../../../utils/entities/permission";

// initialized inside component with translated title

export const ReportMenu: React.FC = () => {
  const { t } = useTranslation();
  const currentLocale = useLocation();
  const navigate = useNavigate();
  const listMenusOpen = useRef([t("reports.consult").toLowerCase()]);
  const { read: readTranscription } = usePermissions(
    FORMS_RELATORIOS.TRASCRIPTION,
  );
  const { read: readLogOperation } = usePermissions(
    FORMS_RELATORIOS.LOG_OPERATION,
  );
  const { read: readLogError } = usePermissions(FORMS_RELATORIOS.LOG_ERROR);
  const { read: readLoggedUsers } = usePermissions(
    FORMS_RELATORIOS.LOGGED_USERS,
  );
  const getListMenuReports = (): Array<IListItem> => {
    const navigationsAux: Array<IListNavigation> = [];

    if (readTranscription) {
      navigationsAux.push({
        id: "transcriptionId",
        menuTitle: t("reports.transcriptions.title"),
        locale: "/report/TranscriptionsReport",
        read: true,
        datacy: "transcricao",
      });
    }
    if (readLogOperation) {
      navigationsAux.push({
        id: "logOperationId",
        menuTitle: t("reports.logOperations.title"),
        locale: "/report/LogOperation",
        read: true,
        datacy: "log-operacoes",
      });
    }
    if (readLogError) {
      navigationsAux.push({
        id: "logErrorId",
        menuTitle: t("reports.logError.title"),
        locale: "/report/LogError",
        read: true,
        datacy: "log-erros",
      });
    }
    if (readLoggedUsers) {
      navigationsAux.push({
        id: "loggedUsersId",
        menuTitle: t("reports.loggedUsers.title"),
        locale: "/report/LoggedUsers",
        read: true,
        datacy: "usuarios-logados",
      });
    }
    return [
      {
        title: t("reports.consult"),
        navigation: navigationsAux,
      },
    ];
  };

  const menuList = useMemo(getListMenuReports, [
    t,
    readTranscription,
    readLogOperation,
    readLogError,
    readLoggedUsers,
  ]);

  const firstAvailableLocale = useMemo(() => {
    const firstGroup = menuList.find((g) => g.navigation?.length);
    return firstGroup?.navigation?.[0]?.locale ?? null;
  }, [menuList]);

  const [noOptions, setNoOptions] = useState(false);

  useEffect(() => {
    const path = currentLocale.pathname.replace(/\/+$/, "");
    if (path === "/report") {
      if (firstAvailableLocale) {
        navigate(firstAvailableLocale, { replace: true });
        setNoOptions(false);
      } else {
        setNoOptions(true);
      }
    } else {
      setNoOptions(false);
    }
  }, [currentLocale.pathname, firstAvailableLocale, navigate]);

  if (noOptions) {
    return <NotFoundPage />;
  }

  return (
    <LeftMenu
      currentLocale={currentLocale.pathname}
      type="report"
      menuTitle={t("reports.title")}
      data-cy="relatorios"
      menuList={menuList}
      backgroundHeader="primary"
      navigate={navigate}
      listMenusOpen={listMenusOpen.current}
    />
  );
};
